import { OptionItem } from "../../sections/TextSection";
import { Field } from "./Field";
import "./styles/tagField.css";

export class TagField extends Field {
  private tags: OptionItem[];
  private input: HTMLInputElement | null = null;
  private tagContainer: HTMLDivElement | null = null;

  constructor(name: string, value: OptionItem[], onChange: (newValue: any) => void) {
    super(name, value, onChange);
    this.tags = Array.isArray(value) ? value : [];
  }

  private createTag(option: OptionItem): HTMLElement {
    const tag = document.createElement('span');
    tag.className = 'tag';   
    
    const controls = document.createElement('div');
    controls.className = 'tag-controls';
    
    const labelText = document.createElement('span');
    labelText.textContent = option.label;
    labelText.title = option.label;
    labelText.style.textOverflow = 'ellipsis';
    labelText.style.overflow = 'hidden';
    labelText.style.width= '80px';

    const visibilityToggle = document.createElement('span');
    visibilityToggle.className = `tag-visibility ${option.showLabel ? '' : 'hidden'}`;
    visibilityToggle.innerHTML = '👁️';
    visibilityToggle.onclick = () => {
      option.showLabel = !option.showLabel;
      visibilityToggle.className = `tag-visibility ${option.showLabel ? '' : 'hidden'}`;
      this.onChange(this.tags);
    };

    const correctToggle = document.createElement('input');
    correctToggle.type = 'checkbox';
    correctToggle.checked = option.isCorrect;
    correctToggle.className = 'tag-correct';
    correctToggle.onchange = (e) => {
      option.isCorrect = (e.target as HTMLInputElement).checked;
      this.onChange(this.tags);
    };
    const isOptionalToggle = document.createElement('input');
    isOptionalToggle.type = 'checkbox';
    isOptionalToggle.checked = (option.isOptional)?option.isOptional:false;
    isOptionalToggle.className = 'tag-correct';
    isOptionalToggle.onchange = (e) => {
      option.isOptional = (e.target as HTMLInputElement).checked;
      this.onChange(this.tags);
    };
    
    const maxWidthValueInput = document.createElement('input');
    maxWidthValueInput.type = 'text';
    maxWidthValueInput.style.width='20px';
    maxWidthValueInput.style.padding='1px';
    maxWidthValueInput.style.borderRadius='4px';
    maxWidthValueInput.value = (option.labelMaxWidth)?option.labelMaxWidth:'';
    maxWidthValueInput.onchange = (e) => {
      option.labelMaxWidth = (e.target as HTMLInputElement).value;
      this.onChange(this.tags);
    };

    const deleteBtn = document.createElement('span');
    deleteBtn.className = 'tag-delete';
    deleteBtn.textContent = '×';
    deleteBtn.onclick = () => this.removeTag(option.label);
    
    controls.appendChild(labelText);
    controls.appendChild(visibilityToggle);
    controls.appendChild(correctToggle);
    controls.appendChild(isOptionalToggle);
    controls.appendChild(maxWidthValueInput);
    controls.appendChild(deleteBtn);
    tag.appendChild(controls);
    
    return tag;
  }

  private removeTag(label: string): void {
    this.tags = this.tags.filter(tag => tag.label !== label);
    this.value = this.tags;
    this.updateTagDisplay();
    this.onChange(this.tags);
  }

  private updateTagDisplay(): void {
    if (this.tagContainer) {
      this.tagContainer.innerHTML = '';
      this.tags.forEach(tag => {
        this.tagContainer?.appendChild(this.createTag(tag));
      });
    }
  }

  public render(): HTMLElement {
    const container = this.createContainer();

    this.tagContainer = document.createElement('div');
    this.tagContainer.className = 'tag-container';
    
    this.input = document.createElement('input');
    this.input.type = 'text';
    this.input.className = 'tag-input';
    this.input.placeholder = 'Type and press Enter';

    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && this.input?.value.trim()) {
        e.preventDefault();
        const newLabel = this.input.value.trim();
        if (!this.tags.some(tag => tag.label === newLabel)) {
          const newTag: OptionItem = {
            label: newLabel,
            isCorrect: false,
            isOptional:false,
            labelMaxWidth:'',
            showLabel:true
          };
          this.tags.push(newTag);
          this.value = this.tags;
          this.updateTagDisplay();
          this.onChange(this.tags);
        }
        this.input.value = '';
      }
    });

    container.appendChild(this.tagContainer);
    container.appendChild(this.input);

    // Initialize with existing tags
    this.updateTagDisplay();
    (container as any)['fieldObj'] = this;

    return container;
  }
}
